import { rootReducer } from "./reducers";
import { applicationErrorSlice } from "./slices";

const { actions: applicationErrorActions } = applicationErrorSlice;

export { applicationErrorActions, rootReducer };
